module.exports = __webpack_public_path__ + "static/fonts/fa-light-300.2c05ac5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-light-300.woff
// module id = 5SFO
// module chunks = 13 14